module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-tag', [_vm._v("[" + _vm._s(this.$route.query.type) + "]-" + _vm._s(this.$route.query.title))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增发布")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium",
      "onclick": "window.history.go(-1)"
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.infos,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "header-row-style": {
        lineHeight: '20px',
        color: '#000'
      },
      "row-style": {
        height: '30px'
      }
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "编号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group_name",
      "label": "所属分类",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "maker_name",
      "label": "创建人",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "make_date",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "disabled": scope.row.sender == null ? false : true,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.sender == null ? false : true,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.handleSend(scope.$index, scope.row)
            }
          }
        }, [_vm._v("发布确认")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "disabled": scope.row.sender == null ? true : false,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.handleCancel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("撤销")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 50, 80, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品组",
      "prop": "app_group"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.appGroupChange,
      "visible-change": _vm.visibleChange
    },
    model: {
      value: (_vm.editForm.app_group),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "app_group", $$v)
      },
      expression: "editForm.app_group"
    }
  }, _vm._l((_vm.appgroups), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.item_name,
        "value": item.item_value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "app_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.app_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "app_id", $$v)
      },
      expression: "editForm.app_id"
    }
  }, _vm._l((_vm.apps), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.app_name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属分类",
      "prop": "group_code"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.group_code),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "group_code", $$v)
      },
      expression: "editForm.group_code"
    }
  }, _vm._l((_vm.discoveryGroups), function(group, index) {
    return _c('el-option-group', {
      key: index,
      attrs: {
        "label": group.group_name
      }
    }, _vm._l((group.children), function(item, i) {
      return _c('el-option', {
        key: i,
        attrs: {
          "label": item.group_name,
          "value": item.group_code
        }
      })
    }))
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "定时显示",
      "prop": "show_time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "formt": "yyyy-MM-dd HH:mm:ss",
      "default-value": new Date()
    },
    model: {
      value: (_vm.editForm.show_time),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "show_time", $$v)
      },
      expression: "editForm.show_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "首页显示设置"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "显示",
      "inactive-text": "不显示"
    },
    on: {
      "change": _vm.showChange
    },
    model: {
      value: (_vm.editForm.first_show),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "first_show", $$v)
      },
      expression: "editForm.first_show"
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.editForm.first_show == true ? false : true,
      "active-text": "置顶",
      "inactive-text": "不置顶"
    },
    model: {
      value: (_vm.editForm.first_top),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "first_top", $$v)
      },
      expression: "editForm.first_top"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属类显示设置"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "推荐区",
      "inactive-text": "非推荐区"
    },
    model: {
      value: (_vm.editForm.show_type),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "show_type", $$v)
      },
      expression: "editForm.show_type"
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "置顶",
      "inactive-text": "不置顶"
    },
    model: {
      value: (_vm.editForm.top),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "top", $$v)
      },
      expression: "editForm.top"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false;
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0b27bc00"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/discovery/releaselist.vue
// module id = 228
// module chunks = 1